import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Card, Form, Input, Spin } from 'antd';
import { useContext } from 'react';
import { AppContext } from '../../AppContext';
import { ROUTES } from '../../common/constants';
import { formItemProps, formValidatorRules } from '../../common/utils';
import FooterContent from '../../components/FooterContent';
import useRouter from '../../hooks/useRouter';
import { AppContextType } from '../../types/appContext.type';
import { UserData } from '../../types/common.type';
import { UsersPermissionsLoginInput } from '../../__generated__/graphql';
import './auth.less';
import { LOGIN } from './graphql/mutations';
import { messageContext } from '../../components/AppContextHolder';

const { required, email } = formValidatorRules;

const Login = () => {
  const [form] = Form.useForm();
  const { navigate } = useRouter();
  const { initializeAuth } = useContext(AppContext) as AppContextType;
  const [loginMutate, { loading: loginLoading }] = useMutation(LOGIN, {
    onError(e) {
      messageContext?.error(
        e?.message || 'Something went wrong. Please try again.',
      );
    },
  });

  function successCallback(
    accessToken: string | null,
    userData: UserData,
    refreshToken?: string | null,
  ) {
    initializeAuth(accessToken, userData, refreshToken);
    navigate(ROUTES.MAIN);
  }

  const onFinish = (values: UsersPermissionsLoginInput) => {
    const formValues = {
      identifier: values?.identifier?.toLowerCase(),
      password: values?.password,
    };
    loginMutate({
      variables: { input: { ...formValues } },
      onCompleted: (response) => {
        if (response?.login?.user) {
          const accessToken = response?.login?.jwt ?? null;
          const userData = response?.login?.user ?? null;

          if (successCallback) {
            successCallback(accessToken, userData);
          }
        } else {
          form?.setFieldsValue(values);
        }
      },
    });
  };

  return (
    <div className="auth-bg">
      <div className="login-wrap d-flex align-center justify-start">
        <Card className="full-width">
          <Spin spinning={loginLoading} wrapperClassName="full-width">
            <h2 className="text-center mb-48">WESTERN TECH</h2>
            <Form
              name="Login"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              size="large"
              form={form}
            >
              <Form.Item
                name="identifier"
                rules={[{ ...required, message: 'Please enter email!' }, email]}
                normalize={formItemProps.normalize}
              >
                <Input prefix={<UserOutlined />} placeholder="Enter email" />
              </Form.Item>

              <Form.Item
                name="password"
                className="mb-32"
                rules={[{ ...required, message: 'Please enter password!' }]}
                normalize={formItemProps.normalize}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Enter password"
                />
              </Form.Item>
              <Form.Item className=" full-width mb-32">
                <Button type="primary" className="full-width" htmlType="submit">
                  Login
                </Button>
              </Form.Item>
            </Form>
          </Spin>
        </Card>
        <FooterContent />
      </div>
    </div>
  );
};

export default Login;
